import $ from 'jquery'

// If the inline tension editor is open, save it silently so modal swapping can continue.
function silentlySubmitOpenTensionFormIfNeeded() {
  const tensionForm = document.querySelector('.js-edit-tension-form')

  if (!tensionForm)
    return Promise.resolve(true)

  if (typeof fetch !== 'function')
    return Promise.resolve(false)

  return fetch(tensionForm.action, {
    method: (tensionForm.method || 'POST').toUpperCase(),
    body: new FormData(tensionForm),
    credentials: 'same-origin',
    headers: {Accept: 'text/vnd.turbo-stream.html, text/html, application/xhtml+xml'},
  })
    .then((response) => response.ok)
    .catch(() => false)
}

// Allow ActionsController#new and ProjectsController#new modals to preserve as much common data as possible.
function swapWorkspaceModals(linkMatcher, formMatcher) {
  $(linkMatcher).on('click', async (event) => {
    event.preventDefault()

    const canContinue = await silentlySubmitOpenTensionFormIfNeeded()
    if (!canContinue)
      return

    const baseUrl = $(event.currentTarget).attr('href')
    const commonFields = ['description', 'focus_icon', 'frequency', 'needed_by_date', 'note', 'parent_goal_or_target', 'person_id', 'projection_date', 'role_id_parent_role_id', 'scheduled_date', 'status', 'tension_id']
    const dataToSerialize = {}
    const formElement = $(formMatcher)[0]
    const formData = new FormData(formElement)
    const separator = (baseUrl.indexOf('?') > 0) ? '&' : '?'

    // Loop through all the fields present in this form.
    formData.entries().forEach(([key, value]) => {
      // Extract ['person_id'] from "project[person_id]"-formatted field names.
      const unscopedKey = key.match(/(?<=\[).+?(?=\])/)

      // If the field is common between Actions and Project AND contains data, then copy it.
      if (unscopedKey && unscopedKey.length > 0 && commonFields.includes(unscopedKey[0]) && value !== '')
        dataToSerialize[unscopedKey] = value
    })

    // Append copied data to the end of the original URL and fire it manually.
    const queryParams = new URLSearchParams(dataToSerialize)
    const url = `${baseUrl}${separator}${queryParams}`

    Turbo.visit(url, {frame: 'remote-modal'})
  })
}

export default {swapWorkspaceModals}
